import client from "./client";

export async function getSalesTotals() {
    const response = await client.get("/user/dashboard/sales-totals");

    return response.data;
}

export async function getPhoneRepresentatives() {
    const response = await client.get("/user/dashboard/phone-representatives");

    return response.data;
}
